module.exports = __webpack_public_path__ + "img/Recovery & reintegration programs.708a3167.png";